<template>
    <div class="px-container mt-6">
        <div
            id="products-controls"
            class="flex flex-wrap flex-col lg:flex-row gap-12 justify-between items-center py-[34px] px-10 border border-xp-line-grey rounded bg-xp-petrol"
        >
            <span class="text-lg font-normal text-white tracking-wide flex-1">Show products by:</span>
            <button
                type="button"
                class="flex items-center gap-6"
                @click.prevent="toggleShowSeries"
            >
                    <span
                        id="products-controls__series"
                        class="text-sm font-bold tracking-[2.51px] uppercase"
                        :class="this.showSeries ? 'text-xp-electron-green' : 'text-white'"
                    >
                        Product series
                    </span>
                <span
                    id="products-controls__switch"
                    class="bg-brand-green relative inline-flex h-[30px] w-[60px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75"
                >
                    <span
                        aria-hidden="true"
                        :class="this.showSeries ? 'translate-x-0' : 'translate-x-[30px]'"
                        class="pointer-events-none inline-block h-[26px] w-[26px] transform rounded-full bg-black shadow-lg ring-0 transition duration-200 ease-in-out"
                    />
                </span>
                <span
                    id="products-controls__models"
                    class="text-sm font-bold tracking-[2.51px] uppercase"
                    :class="!this.showSeries ? 'text-xp-electron-green' : 'text-white'"
                >
                    Part number
                </span>
            </button>
            <form class="products-controls__show-count flex-1 flex justify-end">
                <select
                    class="text-sm text-white font-bold tracking-[2.51px] uppercase border-2 border-white focus:border-white rounded py-4 pl-7 bg-xp-petrol lg:min-w-60 cursor-pointer"
                    name="show_records"
                    id="show_records"
                    @change="setLimit"
                >
                    <option
                        v-for="(limit,index) in limits"
                        :key="index"
                        :value="limit"
                    >
                        Show {{ limit }} results
                    </option>
                </select>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductListToggle',
    props: {
        showSeries: {
            type: Boolean,
            required: true
        },
        limit: {
            type: Number,
            required: true
        }
    },
    data: () => ({
        limits: [
            20,
            50,
            100,
            200
        ]
    }),
    methods: {
        setLimit(e) {
            this.$emit('change-limit', parseInt(e.target.value))
        },
        toggleShowSeries() {
            this.$emit('toggle-show-series')
        }
    },
    computed: {
        seriesActiveClass() {
            return {
                'active': this.showSeries
            }
        },
        modelActiveClass() {
            return {
                'active': !this.showSeries
            }
        },
        toggleSwitchClass() {
            return {
                'left': this.showSeries,
                'right': !this.showSeries,
            }
        },
    }
}
</script>

<style scoped>
select {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%2363E079' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");
}
</style>
